module.exports = __webpack_public_path__ + "img/ali_pay.dab9315d.jpg";